export const RENDER_ICONS_THRESHOLD = 5_000
